import { Decimal as DecimalJS } from 'decimal.js';
export var ExprValue;
(function (ExprValue) {
    function zero() {
        return 0;
    }
    ExprValue.zero = zero;
    function makeString(value) {
        return (value !== null && value !== void 0 ? value : '\0').toString();
    }
    ExprValue.makeString = makeString;
    function parseNumber(value) {
        if (typeof value === 'number') {
            return value;
        }
        if (typeof value === 'string') {
            return new DecimalJS(value);
        }
        if (isDecimal(value)) {
            return value;
        }
        throw new Error(`Cannot create decimal from value ${value}`);
    }
    ExprValue.parseNumber = parseNumber;
    function isDecimal(value) {
        return DecimalJS.isDecimal(value);
    }
    ExprValue.isDecimal = isDecimal;
    function isDecimalSource(value) {
        switch (typeof value) {
            case 'string':
            case 'number': {
                return true;
            }
            default: {
                return isDecimal(value);
            }
        }
    }
    ExprValue.isDecimalSource = isDecimalSource;
    function isExprValue(value) {
        return !(value instanceof Array);
    }
    ExprValue.isExprValue = isExprValue;
    function isSafeNumber(value) {
        if (value == null) {
            return null;
        }
        else {
            if (typeof value === 'number') {
                return isFinite(value);
            }
            if (value.gte(Number.MIN_SAFE_INTEGER) &&
                value.lte(Number.MAX_SAFE_INTEGER)) {
                return true;
            }
            return false;
        }
    }
    ExprValue.isSafeNumber = isSafeNumber;
    function isNumberValue(value) {
        return typeof value === 'number' || DecimalJS.isDecimal(value);
    }
    ExprValue.isNumberValue = isNumberValue;
    function isInteger(value) {
        if (value === null) {
            return false;
        }
        if (typeof value === 'number') {
            return isFinite(value) && Math.floor(value) === value;
        }
        else {
            return value.isInteger();
        }
    }
    ExprValue.isInteger = isInteger;
    function asDecimal(value) {
        if (isDecimal(value)) {
            return value;
        }
        else if (typeof value === 'number' || typeof value === 'string') {
            return new DecimalJS(value);
        }
        else {
            throw new Error(`Cannot create decimal from value ${value}`);
        }
    }
    ExprValue.asDecimal = asDecimal;
    function asSafeNumberValue(value) {
        if (value == null) {
            return value;
        }
        if (typeof value === 'number') {
            return value;
        }
        if (value.lt(Number.MIN_SAFE_INTEGER) ||
            value.gt(Number.MAX_SAFE_INTEGER)) {
            return value.toString();
        }
        return +value;
    }
    ExprValue.asSafeNumberValue = asSafeNumberValue;
    function toBool(value) {
        if (value === null) {
            return value;
        }
        switch (typeof value) {
            case 'boolean': {
                return value;
            }
            case 'number': {
                return value !== 0;
            }
            default: {
                return value !== undefined;
            }
        }
    }
    ExprValue.toBool = toBool;
    function negate(operand) {
        if (operand === null) {
            return null;
        }
        if (typeof operand === 'number') {
            return -1 * operand;
        }
        else if (isDecimal(operand)) {
            return DecimalJS.mul(-1, operand);
        }
        throw new Error(`Unknown operand type -${typeof operand}`);
    }
    ExprValue.negate = negate;
    function add(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left + right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.add(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return right.add(left);
            }
        }
        throw new Error(`Unknown operand types ${typeof left} + ${typeof right}`);
    }
    ExprValue.add = add;
    function sub(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left - right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.sub(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return DecimalJS.sub(left, right);
            }
        }
        throw new Error(`Unknown operand types ${typeof left} - ${typeof right}`);
    }
    ExprValue.sub = sub;
    function mul(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left * right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.mul(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return right.mul(left);
            }
        }
        throw new Error(`Unknown operand types ${typeof left} * ${typeof right}`);
    }
    ExprValue.mul = mul;
    function div(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left / right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.div(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return DecimalJS.div(left, right);
            }
        }
        throw new Error(`Unknown operand types ${typeof left} / ${typeof right}`);
    }
    ExprValue.div = div;
    function mod(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left % right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.mod(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return DecimalJS.mod(left, right);
            }
        }
        throw new Error(`Unknown operand types ${typeof left} % ${typeof right}`);
    }
    ExprValue.mod = mod;
    function abs(value) {
        if (value === null) {
            return null;
        }
        if (typeof value === 'number') {
            return Math.abs(value);
        }
        if (isDecimal(value)) {
            return DecimalJS.abs(value);
        }
        throw new Error(`Cannot calculate absolute value  of ${value}`);
    }
    ExprValue.abs = abs;
    function ceil(value) {
        if (value === null) {
            return null;
        }
        if (typeof value === 'number') {
            return Math.ceil(value);
        }
        if (isDecimal(value)) {
            return DecimalJS.ceil(value);
        }
        throw new Error(`Cannot calculate ceiling of ${value}`);
    }
    ExprValue.ceil = ceil;
    function floor(value) {
        if (value === null) {
            return null;
        }
        if (typeof value === 'number') {
            return Math.floor(value);
        }
        if (isDecimal(value)) {
            return DecimalJS.floor(value);
        }
        throw new Error(`Cannot calculate floor of ${value}`);
    }
    ExprValue.floor = floor;
    function is(left, right) {
        return Object.is(left === null || left === void 0 ? void 0 : left.valueOf(), right === null || right === void 0 ? void 0 : right.valueOf());
    }
    ExprValue.is = is;
    function eq(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left === right;
        }
        if (typeof left === 'string' && typeof right === 'string') {
            return left === right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.eq(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return right.eq(left);
            }
        }
        return left === right;
    }
    ExprValue.eq = eq;
    function neq(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left !== right;
        }
        if (typeof left === 'string' && typeof right === 'string') {
            return left !== right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return !left.eq(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return !right.eq(left);
            }
        }
        return left !== right;
    }
    ExprValue.neq = neq;
    function lt(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left < right;
        }
        if (typeof left === 'string' && typeof right === 'string') {
            return left < right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.lt(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return right.gt(left);
            }
        }
        return left < right;
    }
    ExprValue.lt = lt;
    function lte(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left <= right;
        }
        if (typeof left === 'string' && typeof right === 'string') {
            return left <= right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.lte(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return right.gte(left);
            }
        }
        return left <= right;
    }
    ExprValue.lte = lte;
    function gt(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left > right;
        }
        if (typeof left === 'string' && typeof right === 'string') {
            return left > right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.gt(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return right.lt(left);
            }
        }
        return left > right;
    }
    ExprValue.gt = gt;
    function gte(left, right) {
        if (left === null || right === null) {
            return null;
        }
        if (typeof left === 'number' && typeof right === 'number') {
            return left >= right;
        }
        if (typeof left === 'string' && typeof right === 'string') {
            return left >= right;
        }
        if (isDecimal(left)) {
            if (isNumberValue(right)) {
                return left.gte(right);
            }
        }
        else if (isDecimal(right)) {
            if (isNumberValue(left)) {
                return right.lte(left);
            }
        }
        return left >= right;
    }
    ExprValue.gte = gte;
    function not(operand) {
        if (operand === null) {
            return null;
        }
        if (operand === false) {
            return true;
        }
        return false;
    }
    ExprValue.not = not;
    function or(left, right) {
        if (left === null && right === null) {
            return null;
        }
        left = ExprValue.toBool(left);
        right = ExprValue.toBool(right);
        if (left === null) {
            if (right === false) {
                return null;
            }
            return true;
        }
        if (left === false) {
            if (right === null) {
                return null;
            }
            if (right === false) {
                return false;
            }
        }
        return true;
    }
    ExprValue.or = or;
    function and(left, right) {
        if (left === null || right === null) {
            return null;
        }
        left = ExprValue.toBool(left);
        if (left === false) {
            return false;
        }
        right = ExprValue.toBool(right);
        if (right === false) {
            return false;
        }
        return true;
    }
    ExprValue.and = and;
})(ExprValue || (ExprValue = {}));
